import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SmsConst, SmsStatus } from './sms.const';
import { SocialService } from '../../../../../../common/services/Social.service';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import * as _ from 'lodash';
import { BaseListComponent } from '../../../../../../components/base-list.component';

@Component({
  selector: 'settings-conversation-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.css'],
  providers: [SocialService],
})
export class SmsComponent extends BaseListComponent {
  @ViewChild('smsTemplate') smsTemplate: ElementRef;
  public list: any = [];
  public modalRef2: any;
  public totalRow = 0;
  public display_active_action: any;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private socialService: SocialService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = SmsConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    const payload = await this.buildBasePayload(request, sort);
    await this.socialService.listSms(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.setData(res);
      } else {
        this.data = [];
      }
    });
  }

  setData(res) {
    this.data = res.data.list;
    this.data = this.data.map(res => {
      res.display_status = SmsConst.statusString(res.status);
      res.display_active_action = SmsConst.statusAction(res.status);
      return res;
    });
    this.initPage(res.data.total);
  }

  async createOrUpdate(_id?: any) {
    this.message = null;
    const request = {
      brand_name: this.model.brand_name.trim(),
      note: this.model.note,
      status: '1',
    };
    if (_id) {
      await this.socialService.updateSms(_id, request).subscribe(
        res => {
          if (res.status == 200 && res.error == false) {
            this.throwSuccess('Cập nhật thành công!');
            this.loadData();
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
        }
      );
    } else {
      await this.socialService.createSms(request).subscribe(
        res => {
          if (res.status == 200 && res.error == false) {
            this.throwSuccess('Thêm mới thành công!');
            this.loadData();
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
        }
      );
    }
  }

  async updateStatus(_id: any, status: any) {
    await this.socialService.updateSms(_id, { status: status }).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Cập nhật trạng thái thành công!');
          this.loadData();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      err => {
        this.message = {
          class: 'alert dark alert-danger',
          content: err.message,
        };
      }
    );
  }

  async setupModal(type, item?: any) {
    this.message = null;
    this.typeModal = type;
    if (!item) {
      this.model = {
        brand_name: '',
        note: '',
      };
    } else {
      this.model = {
        brand_name: item.brand_name,
        note: item.note,
        _id: item._id,
      };
    }
    this.modelContent = {
      type: ModalType.Primary,
      title: type == 'edit' ? 'Cập nhật Brandname SMS' : 'Tạo mới Brandname SMS',
      submit_title: type == 'edit' ? 'Cập nhật' : 'Thêm mới',
    };
    this.modelDisplay = [
      {
        key: 'brand_name',
        label: 'Brandname',
        type: FormFieldType.Text,
        value: this.model.brand_name,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: 'note',
        label: 'Mô tả',
        type: FormFieldType.Textarea,
        value: this.model.note,
        required: false,
        disabled: false,
        width: 'full',
        options: { class: 'mh-50' },
        order: 2,
      },
    ];
  }
  async deleteSms(_id?: any) {
    const y = confirm('Bạn có muốn xóa brandname này không?');
    const ids = _id ? [_id] : this.lstChecked;
    if (y) {
      await this.socialService.deleteSms({ ids: ids }).subscribe(
        res => {
          if (!res.error && res.status == 200) {
            const { total, success, failure } = res.data;
            if (success > 0) {
              this.throwSuccess(`Xóa thành công ${success} brandname!`, 'Thông báo');
            }
            if (failure > 0) {
              this.throwWarning(`Xóa thất bại ${failure} brandname! Do brandname đang được sử dụng!`, 'Cảnh báo');
            }
            this.loadData();
          } else {
            this.throwError(res.message);
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    switch (type) {
      case TableAction.add:
        await this.setupModal('add');
        this.openModal(this.smsTemplate, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        await this.setupModal('edit', this.model);
        this.openModal(this.smsTemplate, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        await this.deleteSms(item._id);
        break;
      case TableAction.deleteAll:
        await this.deleteSms();
        break;
      case TableAction.active:
        let status;
        if (item.active == true) {
          status = SmsStatus.Inactive;
        } else {
          status = SmsStatus.Active;
        }
        await this.updateStatus(status, item._id);
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    switch (this.typeModal) {
      case 'add':
        await this.createOrUpdate();
        break;
      case 'edit':
        await this.createOrUpdate(this.model._id);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/sms/sms.component.ts